import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

import { useAppDispatch, useAppSelector } from '@/features';
import { closeModal } from '@/features/slice/event/event-slice';
import { useUpdateUnitMutation } from '@/features/slice/products/unit/unit-api-slice.ts';
import { ProductUnitDto } from '@/types/products';

import { UnitSchema } from '../unit.schema';

export const useEditUnit = () => {
    const unitData = useAppSelector((state) => state.eventSlice.modalData);

    const form = useForm({
        resolver: zodResolver(UnitSchema),
        defaultValues: {
            name: unitData.name || '',
            quantity: unitData.quantity || 0,
            strip_quantity: unitData.strip_quantity || 0,
            id: unitData.id,
        },
    });
    const [editUnit, { isLoading, isSuccess, isError }] =
        useUpdateUnitMutation();

    const {
        handleSubmit,
        formState: { errors },
    } = form;
    const dispatch = useAppDispatch();
    const onSubmit = async (value: ProductUnitDto) => {
        const data = await editUnit({
            name: value.name,
            quantity: value.quantity,
            strip_quantity: value.strip_quantity,
            id: unitData.id,
        }).unwrap();

        if (data.message === 'Success') {
            toast(data.data, {
                style: {
                    background: 'green',
                    color: 'white',
                },
            });
            dispatch(closeModal());
        }

        if (isError) {
            toast.error('error');
        }
    };

    return {
        handleSubmit: handleSubmit(onSubmit),
        form,
        isLoading,
        errors,
        isSuccess,
    };
};
